import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Checkbox } from 'antd';

import * as constants from '../constants';
import {
    setSelectedLocalUserRole
} from '../actions';

import core from '../../core';
import uistate from '../../uistate';
import common from '../../../common';

const { GenericTable } = core;


class LocalUserRoles extends Component {
    selectClicked = (id) => {
        this.props.setSelectedLocalUserRole(id);
    }
    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'LocalUserRoles', key);
    }
    render() {
        const columns = [{
            title: this.label('Role'),
            dataIndex: 'roleName',
            key: 'roleName',
            sorter: (a, b) => a.roleName.length - b.roleName.length,
        }, {
            title:  this.label('Active'),
            dataIndex: 'active',
            key: 'active',
            sorter: (a, b) => a.isGlobalRole - b.isGlobalRole,
            render: (text, record) => (
                <span>
                    <Checkbox disabled checked={record.active} />
                </span>
            ),
        }];

        return (
            <div className='localuserroles'>
                <GenericTable columns={columns} data={this.props.roles} keyfield='roleId' itemName={this.label('Role')} pagesize={20}
                    onSelect={this.selectClicked} />
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        roles: state[constants.NAME].localAppRoles,
        labels : uistate.selectors.uiLabels(state),
    };
}

export default connect(mapStateToProps,
    {
        setSelectedLocalUserRole
    })(LocalUserRoles);  